/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { hasYesOrNo } from 'models/validate';
import { DEFAULT_LATEST, THIS_MONTH, TODAY } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { getSafeDateTime, isSafeDateLater, setToStartOfMonth } from 'helpers/date';
import { formConfig } from 'config/forms';
import { SafeDateTime } from 'helpers/types';
import { isPVQForm } from 'helpers/form';
import { SubstanceThcInvolvementItemModel } from '../types';

const substanceThcInvolvementItemValidator: ValidateJSModel<SubstanceThcInvolvementItemModel> = {

  FirstInvolvement: (value, attributes, attributeName, options) => ({
    presence: true,
    date: { requireDay: false, earliest: setToStartOfMonth(options?.applicantBirthdate), latest: DEFAULT_LATEST },
  }),
  RecentInvolvement: (value, attributes, attributeName, options) => {
    if (!attributes?.FirstInvolvement) {
      return {};
    }

    const formTypeConfig = options?.formType && formConfig[options?.formType as keyof typeof formConfig];
    const applicantEighteenthBirthdate: SafeDateTime | undefined = options?.applicantBirthdate && getSafeDateTime(getSafeDateTime(options?.applicantBirthdate)?.datetime?.plus({ years: 18 }));
    const years: any = formTypeConfig && formTypeConfig.SUBSTANCE_DRUG_USE_YEARS;

    let beyondRequired: SafeDateTime = getSafeDateTime(THIS_MONTH);
    let useDuration = false;

    if (years && beyondRequired?.valid && typeof years === 'number') {
      if (options?.formType && options?.formType === 'SF86' && applicantEighteenthBirthdate?.valid
        && applicantEighteenthBirthdate.datetime.year < (TODAY.year - years)) {
        beyondRequired = setToStartOfMonth(applicantEighteenthBirthdate);
      } else {
        beyondRequired.datetime = beyondRequired?.datetime.minus({ years });
      }

      useDuration = isSafeDateLater(beyondRequired, getSafeDateTime(attributes?.FirstInvolvement));
    }

    return {
      presence: true,
      date: {
        requireDay: false,
        latest: DEFAULT_LATEST,
        earliest: useDuration ? setToStartOfMonth(beyondRequired).datetime : attributes?.FirstInvolvement,
        tooEarly: useDuration ? 'error.beforeDuration' : 'error.drugUsage.min',
      },
    };
  },

  HowManyTimes: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  NatureOfInvolvement: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }
    return { presence: true, hasValue: true };
  },
  Reasons: { presence: true, hasValue: true },
  InvolvementWhileEmployed: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    if (options && options?.requireInvolvementWhileEmployed === false) { return {}; }
    return { presence: true, hasValue: { validator: hasYesOrNo } };
  },
  InvolvementWhileEmployedPosition: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.InvolvementWhileEmployed?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  InvolvementWhileEmployedExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.InvolvementWhileEmployed?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  InvolvementWithClearance: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    if (options && options?.requireInvolvementWithClearance === false) { return {}; }
    return { presence: true, hasValue: { validator: hasYesOrNo } };
  },
  InvolvementWithClearanceExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.InvolvementWithClearance?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  InvolvementInFuture: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    if (options && options?.requireInvolvementInFuture === false) { return {}; }
    return { presence: true, hasValue: { validator: hasYesOrNo } };
  },
  InvolvementInFutureExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  InvolvementInFutureGovernment: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },
  InvolvementInFutureGovernmentExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
};

export default substanceThcInvolvementItemValidator;
